module.exports = __webpack_public_path__ + "media/theme/icon__return--sp-5ff79eac.png";